import { useState, useEffect } from 'react';

const useWindowSize = (mobileThreshold: number = 960) => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= mobileThreshold;

  return { width, isMobile };
};

export default useWindowSize;